<app-toolbar [token]="token" [breadcrumbs]="breadcrumbs" [ProcedureValue]="ProcedureValue"></app-toolbar>

<div class="main-content">

  <button mat-icon-button class="btn-back" (click)="back()">
    <mat-icon>arrow_back</mat-icon>
    Regresar
  </button>

  <section class="row section-container">
    <div class="col s9 ">
      <mat-form-field class="example-full-width" appearance="standard">
        <mat-label>Tipo de sección</mat-label>
        <mat-select [(value)]="tipoSeccion" [disabled]="true">
              <mat-option *ngFor="let tipo of tipoSeccionOptions" [value]="tipo">
                {{tipo}}
              </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col s3">
      Es editable:
      <mat-checkbox
          class="example-margin"
          [(ngModel)]="editableCheck" [disabled]="!isEditableInitial">
      </mat-checkbox>
    </div>
    <button mat-button mat-flat-button
      *ngIf="isEditableInitial"
      (click)="saveChanges()"
              class="aling-checkbox-button background-color-buttom"
              matTooltip="Guardar cambios">
      <mat-icon>save</mat-icon>
      </button>
  </section>

  <div class="row">
    <div class="col s12 ">
      <mat-label><strong>Patron:</strong> {{patron}}</mat-label>
    </div>
  </div>

  <div *ngIf="isEditableInitial">
    <div class="row">
      <div class="col s9">
        <mat-form-field class="example-full-width" appearance="standard">
          <mat-label>Campo literal</mat-label>
          <input matInput [(ngModel)]="search">
        </mat-form-field>
      </div>
      <div class="col s3">

        <button mat-button mat-flat-button
        (click)="cleanSearch()"
                class="aling-checkbox-button search-button"
                matTooltip="Limpiar entrada">
        <mat-icon>clear</mat-icon>
        </button>

        <button mat-button mat-flat-button
        (click)="addToPaht(search)"
                class="aling-checkbox-button background-color-buttom"
                matTooltip="Añadir literal">
        <mat-icon>add</mat-icon>
        </button>

      </div>
    </div>

    <div class="row">

      <div class="col s5 ">
        <cdk-virtual-scroll-viewport itemSize="50" class="scroll-viewport">
          <button *cdkVirtualFor="let campo of campos" class="label-item button-item" (click)="addToPaht(campo)">{{campo}}</button>
        </cdk-virtual-scroll-viewport>
      </div>

      <div class="col s7 ">
        <cdk-virtual-scroll-viewport itemSize="50" class="scroll-viewport">
          <div *cdkVirtualFor="let item of patron_list; let i = index" class="label-item">
            {{item}}
            <div>

              <button mat-flat-button
                    class=" background-color-buttom controll-buttons"
                    (click)="moveItem('up',i)"
                    matTooltip="Mover hacia arriba" >
                <mat-icon> vertical_align_bottom</mat-icon>
              </button>
              <button  mat-flat-button
                      class=" background-color-buttom controll-buttons"
                      (click)="moveItem('down',i)"
                      matTooltip="Mover hacia abajo">
                <mat-icon> vertical_align_top</mat-icon>
              </button>
              <button  mat-flat-button
                      class=" background-color-buttom controll-buttons"
                      (click)="deleteItem(i)"
                      matTooltip="Eliminar">
                <mat-icon> delete</mat-icon>
              </button>

            </div>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
  </div>

</div>



<app-footer></app-footer>
